import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    applyPromotionCodeToSubscription: {
        route: "/workspaces/:workspaceId/billing/subscriptions/promotion-code",
        method: "POST"
    }
};
